// src/api/axiosClient.js
import axios from "axios";

// const API_BASE = "http://localhost:8000/api";
const API_BASE = "https://award-backend.fipi.org.in/api";
// const API_BASE = "http://demo.raygain.com/fipi_awards_backend/api";

const client  = axios.create({
  baseURL: API_BASE,
});

// Attach the access token to every request if present
client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// On 401, try to refresh the token once and retry the original request
let isRefreshing = false;
let failedQueue  = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

client.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalReq = err.config;
    if (err.response?.status === 401 && !originalReq._retry) {
      if (isRefreshing) {
        // queue up the request until token is refreshed
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then((token) => {
          originalReq.headers["Authorization"] = `Bearer ${token}`;
          return client(originalReq);
        })
        .catch(Promise.reject);
      }

      originalReq._retry = true;
      isRefreshing = true;

      const refreshToken = sessionStorage.getItem("refresh_token");
      if (!refreshToken) {
        isRefreshing = false;
        return Promise.reject(err);
      }

      try {
        const { data } = await axios.post(`${API_BASE}/auth/token/refresh/`, {
          refresh: refreshToken,
        });
        sessionStorage.setItem("access_token", data.access);
        client.defaults.headers["Authorization"] = `Bearer ${data.access}`;
        processQueue(null, data.access);
        return client(originalReq);
      } catch (refreshError) {
        processQueue(refreshError, null);
        // if refresh fails, force logout
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("refresh_token");
        window.location.href = "/login";  // or call a logout handler
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(err);
  }
);

export default client;
